export default {
  title: 'Informations de connexion',
  username: 'Nom d\'utilisateur',
  password: 'Mot de passe',
  securityQuestions: 'Questions de sécurité',
  securityQuestionsValue: '3 questions secrètes',
  buttonModify: 'Modifier',
};
